import { render, staticRenderFns } from "./NoImage.vue?vue&type=template&id=6ca6db40&"
import script from "./NoImage.vue?vue&type=script&lang=js&"
export * from "./NoImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1693793820/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ca6db40')) {
      api.createRecord('6ca6db40', component.options)
    } else {
      api.reload('6ca6db40', component.options)
    }
    module.hot.accept("./NoImage.vue?vue&type=template&id=6ca6db40&", function () {
      api.rerender('6ca6db40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/NoImage.vue"
export default component.exports